// Components
import Checkbox from '../../atoms/Checkbox/Checkbox';
// Utils
import cn from '../../../utils/cn';
// Styles
import styles from './CheckboxHeader.module.css';

/**
 * CheckboxHeader component for selecting/deselecting all rows in a table
 * @param {object} props - Component props
 * @param {string} props.id - Unique identifier for the checkbox
 * @param {boolean} props.value - Whether the checkbox is checked
 * @param {boolean} [props.indeterminate=false] - Partial selection (horizontal bar)
 * @param {Function} [props.onChange] - Callback when checkbox is changed
 * @param {boolean} [props.disabled=false] - Whether the checkbox is disabled
 * @param {import('../../atoms/Checkbox/Checkbox').CheckboxSize} [props.size='small'] - Checkbox size
 * @param {import('../../atoms/Checkbox/Checkbox').CheckboxTheme} [props.theme='black'] - Checkbox theme
 * @param {Align} [props.align='center'] - Alignment of the checkbox
 * @returns {JSX.Element} CheckboxHeader component
 */
export default function CheckboxHeader({
  id,
  value = false,
  indeterminate = false,
  onChange = () => {},
  disabled = false,
  size = 'small',
  theme = 'black',
  align = 'left',
}) {
  /**
   * Handle checkbox change
   * @param {React.ChangeEvent<HTMLInputElement>} event - The event object
   */
  const handleChange = (event) => {
    if (!disabled) {
      const newValue = event.target.checked;
      onChange(newValue);
    }
  };

  return (
    <div className={cn([styles['checkbox-header'], styles[`checkbox-header-align-${align}`]])}>
      <Checkbox
        id={id}
        checked={value}
        indeterminate={indeterminate}
        disabled={disabled}
        onChange={handleChange}
        size={size}
        theme={theme}
      />
    </div>
  );
}
